import { FC, useEffect, useState } from "react"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import './adminasignusermodal.css'

import { AutoComplete } from 'primereact/autocomplete';
import { RxCross2 } from 'react-icons/rx'
import { BsCheck2 } from 'react-icons/bs'
import { CiMail } from 'react-icons/ci'
import { InputText } from "primereact/inputtext";
import { catchResponse } from "../../../utils/helperFunctions";
import { getPlants, updateRol } from "../../../services/admin-service";
import { error, success } from "../../../utils/notifications";
import { FiCommand } from "react-icons/fi";

export const AdminAsignUserModal:FC<any> = (props):JSX.Element => {

    const { visible, setVisible, flagGlobal, setFlagGlobal, flagAdmin, setFlagAdmin , nuevo, selectedUser, handleCloseModal, loadingEditUser, setLoadingEditUser, valuesPlanta, setValuesPlanta, roles } = props

    const [items, setItems] = useState<any[]>([]);

    const [email, setEmail] = useState<string>("")

    const [selectedRol, setSelectedRol] = useState<string>(selectedUser.name_rol)

    const [itemsPlanta, setItemsPlanta] = useState<any[]>([])

    useEffect(() => {
        setSelectedRol(selectedUser.name_rol)
    },[selectedUser])

    
    const search = (event:any) => {
        setItems(roles.map((item:any) => item.nombre_rol));
    }

   

    const handleFilterRol = (e:any) => {
        setSelectedRol(e.value)
        if(e.value === 'Administrador' || e.value === 'Estratega') {
            setValuesPlanta([{id: 2, name: 'Briviesca'},{id:3,name: 'Miajadas'},{id:1, name: 'Sangüesa'}])
        } else if(e.value === 'Viewer') setValuesPlanta([])
    }

    const handleUpdateRol = async() => {
        try {
            setLoadingEditUser(true)
            let body:{id_user:string,id_rol:number,id_plants:number[]} = {
                id_user: selectedUser.id_user,
                id_rol : roles.find((i:any) => i.nombre_rol === selectedRol)?.id_rol,
                id_plants : valuesPlanta.map((vp:any) => vp.id)
            }
            
            const res = await updateRol(body)
            if(res.status === 200) {
                const { code, message} = res.data
                if(code === 200) {
                    setLoadingEditUser(false)
                    success(message)
                    setVisible(false)
                    setFlagGlobal(!flagGlobal)
                    setFlagAdmin(!flagAdmin)
                } else if( code === 600) {
                    error(message)
                    setLoadingEditUser(false)

                }
            } else {
                setLoadingEditUser(false)
                error("Error actualizando el rol del usuario.")
            }
        } catch(err:any) {
            setLoadingEditUser(false)
            catchResponse(err)
        }
    }

    const headerContent = (
        <div className="asign-user-header">
            {nuevo?
                <span>Asignación de permisos</span>
            :
                <span>Edición de permisos</span>
            }
            
        </div>
    )


    const footerContent = (
        <div className="asign-user-footer">
            <Button severity={'danger'} label="Cancelar" icon={<RxCross2 style={{fontSize:20, marginRight:'1rem'}} />} onClick={handleCloseModal} outlined disabled={loadingEditUser} />
            <Button severity={'success'} label={nuevo ? "Asignar" : "Actualizar"} icon={loadingEditUser? <FiCommand className="loading-icon" style={{fontSize:15,marginRight:'1rem',color:'#22C55E'}} /> : <BsCheck2 style={{fontSize:20,marginRight:'1rem'}}  />} disabled={(nuevo && (email === "" || selectedRol === "") || loadingEditUser)} onClick={handleUpdateRol}  outlined />
        </div>
    );

    const handleChangePlanta = (e:any) => {
        let aux:number[] = []
        setValuesPlanta(e.value)
        
    }

    const searchPlantas = async() => {
        try {
            const res = await getPlants()
            if(res.status === 200) {
                const {code,data,message} = res.data
                if(code === 200) {
                    let adapted_plants = data.map((plant:any) => ({id:plant.id_planta,name:plant.nombre_planta}))
                    setItemsPlanta(adapted_plants)
                } else {
                    error(message)
                }
            }
            
        } catch(err:any) {
            catchResponse(err)
        }
        
    }

    
    

    return (
        <div className="card flex justify-content-center">
            <Dialog className="dialog-admin-rol" header={headerContent} visible={visible} style={{ width: '45vw', height:'65vh' }} onHide={handleCloseModal} footer={footerContent}>
                <div className="asign-user-modal-container-admin">

                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="email">E-mail</label>
                        <div className="permisos__header-input">
                        <InputText className="scenario-inputs" placeholder="example@acciona.com" onChange={(e:any) => setEmail(e.target.value)} keyfilter="alphanum" value={nuevo? email : selectedUser.email} disabled={!nuevo}   />

                            <span className="p-inputgroup-addon">
                                <CiMail style={{fontSize:20}} />
                            </span>
                        </div>
                        
                    </div>

                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="rol">Rol</label>
                        <AutoComplete disabled={loadingEditUser} inputId="rol" value={selectedRol} suggestions={items} completeMethod={search} onChange={handleFilterRol} dropdown />     
                    </div>

                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="plantas_asignadas">Plantas asignadas</label>
                        <AutoComplete
                            multiple
                            inputId="plantas_asignadas"
                            field="name"
                            value={valuesPlanta}
                            suggestions={itemsPlanta}
                            completeMethod={searchPlantas}
                            onChange={handleChangePlanta}
                            dropdown
                            disabled= {loadingEditUser || [1,4].includes(roles.find((i:any) => i.nombre_rol === selectedRol)?.id_rol)}
                            />
                    </div>
                    

                </div>
            </Dialog>
        </div>
    )
}